<template>
  <div id="sidebar-container" v-if="shouldRender">
    <div class="menu sticky-top">
      <div class="logo mt-3 text-center">
        <img class="img-fluid" src="@/assets/logo.png" width="120" alt="" />
        <hr />
      </div>

      <template v-if="level == 0">
        <template v-if="currPath == '/Home'">
          <router-link
            class="nav-link click menu-items sideBarSelected"
            to="/Home"
          >
            <span class="mr-1">🏠</span>Home
          </router-link>
        </template>
        <template v-else>
          <router-link class="nav-link click menu-items" to="/Home">
            <span class="mr-1">🏠</span>Home
          </router-link>
        </template>
      </template>

      <template v-if="(level == 0) | (level == 1)">
        <template v-if="currPath == '/Main'">
          <router-link
            class="nav-link click menu-items sideBarSelected"
            to="/Main"
          >
            <span class="mr-1">🌐</span>My Stations
          </router-link>
        </template>
        <template v-else>
          <router-link class="nav-link click menu-items" to="/Main">
            <span class="mr-1">🌐</span>My Stations
          </router-link>
        </template>
      </template>

      <template v-if="(level == 0) | (level == 1)">
        <template v-if="currPath == '/nested-stations'">
          <router-link
            class="nav-link click menu-items sideBarSelected"
            to="/nested-stations"
          >
            <span class="mr-1">🧱</span>Nested stations
          </router-link>
        </template>
        <template v-else>
          <router-link class="nav-link click menu-items" to="/nested-stations">
            <span class="mr-1">🧱</span>Nested stations
          </router-link>
        </template>
      </template>
      <template v-if="(level == 0) | (level == 1)">
        <template v-if="currPath == '/soil-scouts'">
          <router-link
            class="nav-link click menu-items sideBarSelected"
            to="/soil-scouts"
          >
            <span class="mr-1">🌱</span>Soil Scouts
          </router-link>
        </template>
        <template v-else>
          <router-link class="nav-link click menu-items" to="/soil-scouts">
            <span class="mr-1">🌱</span>Soil Scouts
          </router-link>
        </template>
      </template>

      <template v-if="(level == 0) | (level == 1)">
        <template v-if="currPath == '/manual-records'">
          <router-link
            class="nav-link click menu-items sideBarSelected"
            to="/manual-records"
          >
            <span class="mr-1">✌️</span>Manual Records
          </router-link>
        </template>
        <template v-else>
          <router-link class="nav-link click menu-items" to="/manual-records">
            <span class="mr-1">✌️</span>Manual Records
          </router-link>
        </template>
      </template>

      <template v-if="(level == 0) | (level == 1)">
        <template v-if="currPath == '/lightning-strikes'">
          <router-link
            class="nav-link click menu-items sideBarSelected"
            to="/lightning-strikes"
          >
            <span class="mr-1">⛅</span>Internet Weather
          </router-link>
        </template>
        <template v-else>
          <router-link
            class="nav-link click menu-items"
            to="/lightning-strikes"
          >
            <span class="mr-1">⛅</span>Internet Weather
          </router-link>
        </template>
      </template>

      <template v-if="(level == 0) | (level == 1)">
        <template v-if="currPath == '/droplets'">
          <router-link
            class="nav-link click menu-items sideBarSelected"
            to="/droplets"
          >
            <span class="mr-1">💧</span>Droplets
          </router-link>
        </template>
        <template v-else>
          <router-link class="nav-link click menu-items" to="/droplets">
            <span class="mr-1">💧</span>Droplets
          </router-link>
        </template>
      </template>

      <template v-if="(level == 0) | (level == 2)">
        <template v-if="currPath == '/qr'">
          <router-link
            class="nav-link click menu-items sideBarSelected"
            to="/qr"
          >
            <span class="mr-1">📇</span>Inventory
          </router-link>
        </template>
        <template v-else>
          <router-link class="nav-link click menu-items" to="/qr">
            <span class="mr-1">📇</span>Inventory
          </router-link>
        </template>
      </template>

      <!-- <template v-if="level==0 | level==2">
                <template v-if="currPath=='/inventory'">
                    <router-link class="nav-link click menu-items text-danger sideBarSelected" to="/inventory">
                        <span class="mr-1">📇</span>Inventory TEST
                    </router-link>
                </template>
                <template v-else>
                    <router-link class="nav-link click menu-items text-danger" to="/inventory">
                        <span class="mr-1">📇</span>Inventory TEST
                    </router-link>
                </template>
            </template> -->

      <template v-if="(level == 0) | (level == 2)">
        <template v-if="currPath == '/repairs'">
          <router-link
            class="nav-link click menu-items sideBarSelected"
            to="/repairs"
          >
            <span class="mr-1">🛠️</span>In-Office Work Orders
          </router-link>
        </template>
        <template v-else>
          <router-link class="nav-link click menu-items" to="/repairs">
            <span class="mr-1">🛠️</span>In-Office Work Orders
          </router-link>
        </template>
      </template>

      <template v-if="(level == 0) | (level == 2)">
        <template v-if="currPath == '/remote'">
          <router-link
            class="nav-link click menu-items sideBarSelected"
            to="/remote"
          >
            <span class="mr-1">📱</span>Remote Support
          </router-link>
        </template>
        <template v-else>
          <router-link class="nav-link click menu-items" to="/remote">
            <span class="mr-1">📱</span>Remote Support
          </router-link>
        </template>
      </template>

      <template v-if="(level == 0) | (level == 2)">
        <template v-if="currPath == '/field'">
          <router-link
            class="nav-link click menu-items sideBarSelected"
            to="/field"
          >
            <span class="mr-1">🌳</span>Field Work Orders
          </router-link>
        </template>
        <template v-else>
          <router-link class="nav-link click menu-items" to="/field">
            <span class="mr-1">🌳</span>Field Work Orders
          </router-link>
        </template>
      </template>

      <template v-if="level == 0">
        <template v-if="currPath == '/Ids'">
          <router-link
            class="nav-link click menu-items sideBarSelected"
            to="/Ids"
          >
            <span class="mr-1">🆔</span>API IDs
          </router-link>
        </template>
        <template v-else>
          <router-link class="nav-link click menu-items" to="/Ids">
            <span class="mr-1">🆔</span>API IDs
          </router-link>
        </template>
      </template>

      <template v-if="(level == 0) | (level == 2)">
        <template
          v-if="
            (currPath == '/company') |
              (currPath == '/users') |
              (currPath == '/lunch')
          "
        >
          <a
            class="nav-link click menu-items sideBarSelected"
            href="#submenu1"
            data-toggle="collapse"
            data-target="#submenu1"
            to="/jobs"
          >
            <span class="mr-1">⚙️</span> Administration
          </a>
          <div class="collapse" id="submenu1" aria-expanded="false">
            <ul class="flex-column pl-2 nav">
              <li class="nav-item ml-3 ">
                <template v-if="currPath == '/company'">
                  <router-link
                    class="nav-link click menu-items sideBarSelected"
                    to="/company"
                  >
                    <span class="mr-1">🏢</span>Company
                  </router-link>
                </template>
                <template v-else>
                  <router-link class="nav-link click menu-items" to="/company">
                    <span class="mr-1">🏢</span>Company
                  </router-link>
                </template>
              </li>
              <li class="nav-item ml-3">
                <template v-if="currPath == '/users'">
                  <router-link
                    class="nav-link click menu-items sideBarSelected"
                    to="/users"
                  >
                    <span class="mr-1">👥</span>Users
                  </router-link>
                </template>
                <template v-else>
                  <router-link class="nav-link click menu-items" to="/users">
                    <span class="mr-1">👥</span>Users
                  </router-link>
                </template>
              </li>
              <li class="nav-item ml-3">
                <template v-if="currPath == '/lunch'">
                  <router-link
                    class="nav-link click menu-items sideBarSelected"
                    to="/lunch"
                  >
                    <span class="mr-1">🍴</span>Lunch Control
                  </router-link>
                </template>
                <template v-else>
                  <router-link class="nav-link click menu-items" to="/lunch">
                    <span class="mr-1">🍴</span>Lunch Control
                  </router-link>
                </template>
              </li>
            </ul>
          </div>
        </template>
        <template v-else>
          <a
            class="nav-link click menu-items"
            href="#submenu1"
            data-toggle="collapse"
            data-target="#submenu1"
            to="/jobs"
          >
            <span class="mr-1">⚙️</span> Administration
          </a>
          <div class="collapse" id="submenu1" aria-expanded="false">
            <ul class="flex-column pl-2 nav">
              <li class="nav-item ml-3">
                <router-link class="nav-link click menu-items" to="/company">
                  <span class="mr-1">🏢</span>Company
                </router-link>
              </li>
              <li class="nav-item ml-3">
                <router-link class="nav-link click menu-items" to="/users">
                  <span class="mr-1">👥</span>Users
                </router-link>
              </li>
              <li class="nav-item ml-3">
                <router-link class="nav-link click menu-items" to="/lunch">
                  <span class="mr-1">🍴</span>Lunch Control
                </router-link>
              </li>
            </ul>
          </div>
        </template>
      </template>

      <hr />

      <span @click="logOut()" class="nav-link click menu-items"
        ><i class="fas fa-chevron-left mr-3 text-danger"></i> Logout</span
      >
    </div>
  </div>
</template>

<script>
import { firebaseApp } from "../fb";
export default {
  name: "sidebar",
  props: ["shouldRender"],
  data() {
    return {
      drawer: false,
      direction: "ltr",
      url: "",
      apiNickname: "",
      user: "",
      name: "",
      apiObject: [],
      apiObjectLength: 0,
      editName: "",
      editApi: "",
      editIndex: "",
      dbname: "",
      dbpass: "",
      dbuser: "",
      lvl: false,
      level: 0,
      apiOrigin: false,
      popupNest: false,
      selectedName: "",
      apiName: "",
      apiValue: "",
      selectedPath: "",
      colorx: "#3DC9B3",
      currPath: null,
    };
  },
  beforeMount() {
    this.readPath();
  },
  mounted() {
    this.getInitialData();
    this.selectedPath = this.$route.name;
  },
  crated() {},
  methods: {
    readPath() {
      console.log(this.$route);
      this.currPath = this.$route.path;
    },
    logOut() {
      this.loading = false;
      firebaseApp.auth().signOut();
    },
    getInitialData() {
      var vm = this;
      vm.apiObject = [];
      firebaseApp.auth().onAuthStateChanged(function(user) {
        if (!user) {
          vm.$router.push("/");
        } else {
          vm.user = user.uid;
          firebaseApp
            .database()
            .ref("users/" + user.uid)
            .once(
              "value",
              function(snapshot) {
                var data = snapshot.val();
                vm.name = data.name;
                vm.dbname = data.dbname;
                vm.dbuser = data.dbuser;
                vm.dbpass = data.dbpass;
                vm.level = data.lvl;
                if (data.lvl == 0) {
                  vm.lvl = true;
                }
                if (data.nestedApi) {
                  vm.apiObject = data.nestedApi;
                  vm.apiObjectLength = vm.apiObject.length;
                }
              },
              function(errorObject) {
                vm.sendNotify(
                  "Error",
                  "Something went wrong",
                  "error",
                  "highlight_off"
                );
                return;
              }
            );
        }
      });
    },
  },
  watch: {
    $route() {
      const button = this.$refs.menuTop.$el.querySelector(
        ".vs-navbar--btn-responsive"
      );
      button.click();
    },
  },
};
</script>
